import {FuelAlertVariant} from '../../Alert';
import {Theme} from '../../ThemeProvider';
import {svgIconClasses} from '@mui/material';
import {CSSProperties} from 'react';

const iconClassName = `& .${svgIconClasses.root}`;

type GetColors = (theme: Theme, variant?: FuelBadgeVariant) => CSSProperties;

export type FuelBadgeVariant = FuelAlertVariant;

export const getDefaultColors: GetColors = (theme, variant) => ({
    backgroundColor: theme.tokens.FuelColorGray200,
    color: theme.tokens.FuelColorTextPrimary,
    [iconClassName]: {
        color: theme.tokens.FuelColorGray900
    },
    ...variant === 'success' && {
        backgroundColor: theme.tokens.FuelColorGreen200,
        [iconClassName]: {
            color: theme.tokens.FuelColorGreen700
        }
    },
    ...variant === 'info' && {
        backgroundColor: '#c4daed',
        [iconClassName]: {
            color: '#005db1'
        }
    },
    ...variant === 'warning' && {
        backgroundColor: '#fee7c4',
        [iconClassName]: {
            color: '#F99700'
        }
    },
    ...variant === 'error' && {
        backgroundColor: '#f1c8cc',
        [iconClassName]: {
            color: '#C21020'
        }
    }
});

export const getBoldColors: GetColors = (theme, variant) => ({
    backgroundColor: theme.tokens.FuelColorGray700,
    color: theme.tokens.FuelColorWhite,
    ...variant === 'success' && {
        backgroundColor: theme.tokens.FuelColorGreen700
    },
    ...variant === 'info' && {
        backgroundColor: '#005db1'
    },
    ...variant === 'warning' && {
        backgroundColor: '#F99700',
        color: theme.tokens.FuelColorGray1000
    },
    ...variant === 'error' && {
        backgroundColor: '#C21020'
    }
});
